import { get } from '@/utils/vuex'

export default {
  list: get('list'),
  listLoading: get('listLoading'),
  record: get('record'),
  recordLoading: get('recordLoading'),
  totalCount: get('totalCount')
}
